const state = {
  routerList: []
}

const mutations = {
  SET_ROUTER_LIST(state, obj) {
    if ((obj && obj.toName === 'transfer') || obj.name === 'transfer') {
      return
    }
    if (obj.name) {
      // 无名之辈，休想加入面包屑
      const routerList = state.routerList.map(item => item)
      // 将新来的路由添加到路由列表的最后
      routerList.push(obj)
      // 临时的路由列表
      const routerListTemp = []
      // 对路由列表进行遍历，并将符合条件的路由放至临时路由列表中
      for (let i = 0, len = routerList.length; i < len; i += 1) {
        // 首页不需要
        if (obj.routerName === 'Home') {
          break
        }
        // 解决问题：页面进行返回操作后，再次进入相同页面，路由重复的问题
        if (obj.toName === routerList[i].toName) {
          routerListTemp.push(routerList[i])
          break
        }
        // 解决问题：如果进入的页面跟当前路由一致，那么到当前位置即可，后面的路由也不需要了
        if (obj.toName === routerList[i].routerName) {
          break
        }
        // 符合条件的路由，放至临时路由列表中
        routerListTemp.push(routerList[i])
      }
      state.routerList = routerListTemp
    }
  },
  CLEAR_ROUTER_LIST(state) {
    state.routerList = []
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
